var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-content"},[(_vm.detail)?_c(_vm.comName,{ref:"com",tag:"components",attrs:{"itemData":_vm.itemData,"detail":_vm.detail,"examInfo":_vm.examInfo,"infoData":_vm.infoData,"onFinish":_vm.onFinish}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }